import { PageData } from '@/gem.types';
import timezones from 'timezones-list';

interface Props {
  timezone: string;
  onTimezoneChange: (timezone: string) => void;
  loading: boolean;
  theme: PageData['theme']
  selectedDate: Date;
  timeslots: string[];
  onSelect: (time: string) => void;
}

// Component
const TimeSlots = ({
                     timezone,
                     onTimezoneChange,
                     loading,
                     theme,
                     selectedDate,
                     timeslots,
                     onSelect
                   }: Props) => {
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  };

  if (!loading && timeslots.length === 0) {
    return (
      <div className="w-full mx-auto flex flex-col items-center">
        <h1
          className="text-center text-xl font-bold mb-2"
          style={{ color: theme?.textColor || '#333' }}
        >
          No timeslots available for this day
        </h1>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto flex flex-col items-center">
      <h1
        className="text-center text-xl font-bold mb-2"
        style={{ color: theme?.textColor || '#333' }}
      >
        {formatDate(selectedDate)}
      </h1>

      {loading ? (
        <>Loading...</>
      ) : (
        <>
          {timeslots.map((time, index) => (
            <div
              key={index}
              className="text-lg px-0 py-2 my-2.5 w-11/12 text-center rounded-lg border cursor-pointer transition duration-200 ease-in-out hover:-translate-y-1"
              style={{
                backgroundColor: theme?.containerColor || 'rgb(243, 244, 246)',
                borderColor: theme?.borderColor || '#333',
                color: theme?.containerTextColor || '#333',
                fontWeight: 400,
                fontSize: '18px'
              }}
              onClick={() => {
                onSelect(time);
              }}
            >
              <span className="mr-2 text-xl" style={{ color: theme?.primaryColor || '#4450ce' }}>
                <span>&#9679;</span> {time}
              </span>
            </div>
          ))}
          <select
            value={timezone}
            onChange={(e: any) => onTimezoneChange(e.target.value)}
            className="px-2 py-2 mb-6 rounded-lg text-sm w-11/12 outline-none text-center appearance-none mt-3 border"
            style={{
              backgroundColor: theme?.containerColor || '#f8f7f4',
              color: theme?.containerTextColor || '#333',
              borderColor: theme?.fieldBorderColor || '#333',
              fontSize: '12px'
            }}
          >
            {timezones.map((tz) => (
              <option key={tz.tzCode} value={tz.tzCode}>
                {tz.label}
              </option>
            ))}
          </select>
        </>
      )}
    </div>
  );
};

export default TimeSlots;
